<template>
  <footer class="footer w-full py-3">
    <h6 class="text-white text-center">版權所有 2024 LiveABC互動英語教學集團 Hebron Soft Limited All Rights Reserved</h6>
  </footer>
</template>

<script>
export default {
  name: 'footerSection',
  props: {
  },
  data () {
    return {
    }
  },
  mounted () {

  },
  methods: {

  }
}
</script>
<style lang="scss" scoped>
.footer {
  background: #5A5D9B;
  @media (max-width: 769px) {
    background: #0E103E;
  }
}
</style>